<!-- Overlay if the context is not valid -->
@if ((contextIsValid$ | async) === false) {
  <div
    class="overlay">
  </div>
}

<div class="way-component--filterable-container">

  <!-- Filter -->
  <div [appHidden]="clashMode" class="way-filter-container">
    <app-filter [parentSourceView]="view" [dataForFilter$]="aircraftPlanning$"></app-filter>
  </div>

  <!-- Header  -->
  <div class="way-component--header">

    <span class="way-component--header-title">{{ 'APP_TAB_AIRCRAFT_PLANNING' | translate }}
      @if (clashMode) {
        <span> &#47; {{ 'UPLOAD_PLANNING' | translate }} &#47; {{ 'CLASHES' | translate }}</span>
      }
    </span>

    <form [appHidden]="clashMode" [formGroup]="dateForm">
      <mat-form-field appearance="outline" class="never-hint">
        <mat-date-range-input [rangePicker]="picker">
          <input readonly matStartDate formControlName="fromDate" placeholder="{{ 'START_DATE' | translate }}">
          <input readonly matEndDate formControlName="toDate" placeholder="{{ 'END_DATE' | translate }}"
            (dateChange)="refreshData()">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </form>

      <div class="way-component--header-buttons">
        @if (!clashMode) {
          <button mat-stroked-button color="primary" (click)="refreshData()">
            <fa-icon icon="sync-alt"></fa-icon>
            {{ 'REFRESH_DATA' | translate }}
          </button>
        }
        @if (trackerPlanningManager && !clashMode) {
          <button mat-flat-button color="primary" (click)="uploadAircraftPlanning()">
            <fa-icon icon="plus-circle"></fa-icon>
            {{ 'UPLOAD_PLANNING' | translate }}
          </button>
        }
        @if (trackerPlanningManager && clashMode) {
          <button mat-flat-button color="primary" (click)="uploadAircraftPlanning()">
            {{ 'NEXT' | translate }}
          </button>
        }
      </div>
    </div>

    <!-- Loader -->
    <div [appHidden]="!loader" class="overlay">
      <mat-progress-spinner class="spinner" mode="indeterminate" value="50">
      </mat-progress-spinner>
    </div>

    <!-- Table -->
    <div class="way-table--main-container">

      <!-- Live filtering on aircraft planning status type -->
      <div class="planning-type-selector">
        <mat-button-toggle-group data-color="primary"
          value="all">
          @for (count of aircraftPlanningCount | appPlanningCountKeyvalue; track count) {
            <mat-button-toggle
              [value]="count.key"
              class="planning-type-selector-item"
              (click)="liveFilterAircraftPlanning(count.key)">
              <span class="title">{{ count.key | uppercase | translate }}</span>
              &nbsp;
              <span class="number-{{ count.key }}">{{ count.value }}</span>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>

      <div class="table-container mat-elevation-z8 custom-scrollbar">

        <table class="way-table" [attr.aria-label]="'ARIA_AIRCRAFT_PLANNING_TABLE' | translate" #table mat-table matSort
          [dataSource]="dataSource">

          @for (col of displayedColumns; track col; let colIndex = $index) {
            <ng-container [matColumnDef]="col">
              <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header
                [disabled]="col === 'actions' || col === 'status'">
                @if (col !== 'actions') {
                  <span>{{ col | uppercase | translate }}</span>
                }
              </th>
              <td mat-cell *matCellDef="let element">
                <!-- Status columns -->
                @if (col === 'status') {
                <p [ngClass]="{
                       'green': element.status?.type?.toLowerCase() === 'success',
                       'warn': element.status?.type?.toLowerCase() === 'error',
                       'orange': element.clashes?.length
                   }"
                    class="planning-status">
                    @if (element.status?.type?.toLowerCase() === 'success') {
                      <fa-icon icon="check"></fa-icon>
                    }
                    @if (element.status?.type?.toLowerCase() === 'error') {
                      <fa-icon icon="exclamation-triangle"></fa-icon>
                    }
                    {{ element[displayedColumns[colIndex]]?.message | translate }}
                    @for (message of messagesClashes[element.id]; track message) {
                      <span>
                        <p>
                          <fa-icon icon="exclamation-triangle"></fa-icon>
                          {{message}}
                        </p>
                      </span>
                    }
                  </p>
                }
                <!-- Date columns -->
                @if (col === 'arrivalTime') {
                  <p>{{ (element[displayedColumns[colIndex]] | typeOf) === 'date' ? (element[displayedColumns[colIndex]] | moment:'L LT') : element[displayedColumns[colIndex]] }}</p>
                }
                <!-- Zone columns -->
                @if (col === 'currentPosition' || col === 'futurePosition') {
                  <p>{{ element[displayedColumns[colIndex]]?.name }}</p>
                }
                <!-- Normal columns -->
                @if (col !== 'actions' && col !== 'arrivalTime' && col !== 'status' && col !== 'currentPosition' && col !== 'futurePosition') {
                  <p>{{ element[displayedColumns[colIndex]] }}</p>
                }
                <!-- Actions columns -->
                @if (col === 'actions') {
                  <div class="action-column">
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation()">
                      <fa-icon icon="ellipsis-v"></fa-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu" xPosition="before">
                      <button mat-menu-item focusable="false"
                        [disabled]="!trackerPlanningManager || moment(element.arrivalTime).isBefore(moment(), 'day')"
                        (click)="openEditDialog(element)">
                        <fa-icon icon="pencil-alt"
                        [fixedWidth]="true"></fa-icon>
                        {{ 'EDIT' | translate }}
                      </button>
                      <button class="warn" mat-menu-item focusable="false" [disabled]="!trackerPlanningManager"
                        (click)="deleteEditDialog(element)">
                        <fa-icon icon="trash"
                        [fixedWidth]="true"></fa-icon>
                        {{ 'DELETE' | translate }}
                      </button>
                    </mat-menu>
                  </div>
                }
              </td>
            </ng-container>
          }

          <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="table-row"></tr>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky : true"></tr>

        </table>

      </div>

      <mat-paginator class="way-table--footer" (page)="scrollUp()" [pageSizeOptions]="[25, 50, 100]"></mat-paginator>

    </div>

  </div>
